import { useState } from "react";
import { CompoundInterestInputCard } from "./components/CompoundInterestInputCard";
import { CompoundInterestResponse } from "./components/CompoundInterestResponse";

export default function JurosCompostos() {
  const [results, setResults] = useState<ResultsType | null>(null);


  return (
    <>
      <CompoundInterestInputCard setResults={setResults} />
      {results && <CompoundInterestResponse results={results} />}
    </>
  );
}
